export var ON_NEW_MESSAGE;
(function (ON_NEW_MESSAGE) {
    ON_NEW_MESSAGE["SHOW_NOTIFICATION"] = "showNotification";
    ON_NEW_MESSAGE["EXPAND"] = "expand";
})(ON_NEW_MESSAGE || (ON_NEW_MESSAGE = {}));
//# sourceMappingURL=behaviour.js.map